<template>
    <div class="work-organisation">
        <div class="container-fluid">
            <div class="row justify-content-center d-none d-md-block">
                <table style="width:100%" class="">
                    <tr>
                        <td v-if="hideoverview == false" style="width: 130px;">
                            <div class="p-1 large-button rounded" v-bind:class="{'selected':step == 1}" @click="step = 1">
                                <span v-html="$t('workorganisation_overview')"></span>
                            </div>
                        </td>
                        <td v-if="hidedefinepositions == false" class="p-1 text-center">
                            <img src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hidedefinepositions == false" style="width: 130px;">
                            <div data-testid="workorganisation-step-define-positions" class="p-1 large-button rounded" v-bind:class="{'selected':step == 2}" @click="goToDefinePositionsStep">
                                <span v-html="$t('workorganisation_define_positions')"></span>
                            </div>
                        </td>
                        <td v-if="hideworkcontentanddevelopment == false" class="p-1 text-center">
                            <img alt="Till Arbetsinnehåll & utveckling" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hideworkcontentanddevelopment == false" style="width: 130px;">
                            <div data-testid="workorganisation-step-work-content" class="p-1 large-button rounded" v-bind:class="{'selected':step == 3}" @click="goToWorkContentStep">
                                <span v-html="$t('workorganisation_work_and_development')"></span>
                            </div>
                        </td>
                        <td v-if="hidedevelopmentblocks == false" class="p-1 text-center">
                            <img alt="Till Utvecklingsblock" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hidedevelopmentblocks == false" style="width: 130px;">
                            <div data-testid="workorganisation-step-development-blocks" class="p-1 large-button rounded" v-bind:class="{'selected':step == 4}" @click="step = 4">
                                <span v-html="$t('workorganisation_developmentblocks')"></span>
                            </div>
                        </td>
                        <td v-if="hidedistributetasks == false" class="p-1 text-center">
                            <img alt="Till Fördela arbetsuppgifter" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hidedistributetasks == false" style="width: 130px;">
                            <div data-testid="workorganisation-step-distribute-tasks" class="p-1 large-button rounded" v-bind:class="{'selected':step == 5}" @click="goToDistributeTasksStep">
                                <span v-html="$t('workorganisation_define_worktasks')"></span>
                            </div>
                        </td>
                        <td v-if="hideworkdescription == false" class="p-1 text-center">
                            <img alt="Till Arbetsbeskrivning" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hideworkdescription == false" style="width: 130px;">
                            <div data-testid="workorganisation-step-work-description" class="p-1 large-button rounded" v-bind:class="{'selected':step == 6}" @click="step = 6">
                                <span v-html="$t('workorganisation_workdescription')"></span>
                            </div>
                        </td>
                    </tr>

                </table>
            </div>
            <div class="row justify-content-center mt-3 p-0">
                <div v-if="hideoverview == false" class="p-0 d-block d-md-none col-12">
                    <div class="blue my-1 mobile-button rounded" v-bind:class="{'selected':step == 1}" @click="step = 1">
                        <span v-html="$t('workorganisation_overview')"></span>
                    </div>
                </div>
                <div v-if="step == 1" class="col-12 p-0">
                    <v-expansion-panels variant="accordion">
                        <v-expansion-panel eager
                            data-manual-info-block="workorganisation-foundation-data"
                            data-manual-info-scope="Module"
                            data-manual-module="WorkOrganisation"
                            data-manual-overview-section="WorkOrganisation"
                            data-manual-complexity="Enkel"
                            data-manual-info-tags="workorganisation,foundation-data,workflow">
                            <v-expansion-panel-title class="tab-title" data-manual-info-title>
                                {{$t('workorganisation_tab1_to_develop_org_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div data-manual-info-body v-html="$t('workorganisation_tab1_to_develop_org_text')"></div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-title class="tab-title">
                                {{$t('workorganisation_tab1_positiondevelopment_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div v-html="$t('workorganisation_tab1_positiondevelopment_text')"></div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-title class="tab-title">
                                {{$t('workorganisation_tab1_workprocess_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div v-html="$t('workorganisation_tab1_workprocess_text')"></div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-title class="tab-title">
                                {{$t('workorganisation_tab1_what_to_think_about_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div v-html="$t('workorganisation_tab1_what_to_think_about_text')"></div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-title class="tab-title">
                                {{$t('workorganisation_tab1_tool_local_regulation_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div class="mt-5">
                                    <common-rule v-bind:disabled="writeoverview == false" regulationtype="3"></common-rule>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>

                </div>

                <div v-if="hidedefinepositions == false" class="p-0 d-block d-md-none col-12">
                    <div data-testid="workorganisation-step-define-positions" class="blue my-1 mobile-button rounded" v-bind:class="{'selected':step == 2}" @click="goToDefinePositionsStep">
                        <span v-html="$t('workorganisation_define_positions')"></span>
                    </div>
                </div>
                <div v-if="step == 2" class="col-12 p-0">
                    <v-expansion-panels variant="accordion">
                        <v-expansion-panel>
                            <v-expansion-panel-title class="tab-title">
                                {{$t('workorganisation_tab2_what_is_workposition_development_title')}}

                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div v-html="$t('workorganisation_tab2_what_is_workposition_development_text')"></div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-title class="tab-title">
                                {{$t('workorganisation_tab2_tool_define_positions_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <manage-workpositions v-bind:disabled="writedefinepositions == false" v-bind:model="internalModel" v-bind:selectedJobPosition="selectedJobPosition" @position-selected="positionSelected" @job-positions-changed="jobPositionsChanged"></manage-workpositions>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>


                </div>

                <div v-if="hideworkcontentanddevelopment == false" class="p-0 d-block d-md-none col-12">
                    <div data-testid="workorganisation-step-work-content" class="blue my-1 mobile-button rounded" v-bind:class="{'selected':step == 3}" @click="goToWorkContentStep">
                        <span v-html="$t('workorganisation_work_and_development')"></span>
                    </div>
                </div>
                <div v-if="step == 3" class="col-12 p-0">
                    <v-expansion-panels variant="accordion">
                        <v-expansion-panel>
                            <v-expansion-panel-title class="tab-title">
                                {{$t('workorganisation_tab3_how_can_positions_develop_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div v-html="$t('workorganisation_tab3_how_can_positions_develop_text')"></div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-title class="tab-title">
                                {{$t('workorganisation_tab3_sbb_template_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div v-html="$t('workorganisation_tab3_sbb_template_text')"></div>



                                <v-expansion-panels variant="accordion">
                                    <v-expansion-panel>
                                        <v-expansion-panel-title color="success">
                                            {{$t('workorganisation_tab3_sbb_template_tab1_five_core_areas_title')}}
                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text>

                                            SBB bygger på att arbetet kan utvecklas inom fem olika arbetsområden. De är:<ol>
                                                <li>
                                                    <b>Kärnarbete</b><br>
                                                    Det är traditionella produktionsuppgifter som montering, bearbetning, materialhanter¬ing, processteknik, fordonsteknik, svetsteknik och underhåll. Till kärnarbetet kan flera sammanhängande direkta och
                                                    indirekta produktionsarbetsuppgifter höra.
                                                </li>

                                                <li>
                                                    <b>Kompletterande arbetsuppgifter</b><br>
                                                    Kompletterande arbetsuppgifter eller kringarbete är också traditionella produktionsuppgifter. De skiljer sig från kärnarbetet genom att kunskaperna som krävs är helt andra.
                                                    För en montör kan det exempelvis innebära materialhantering, truckkörning och packning.
                                                </li>

                                                <li>
                                                    <b>Förberedande och uppföljande arbetsuppgifter</b><br>
                                                    Det är arbetsuppgifter inom planering, beredning, kvalitet, programmering och arbetsfördelning samt tillhörande rapportering.
                                                </li>

                                                <li>
                                                    <b>Sociala arbetsuppgifter</b><br>
                                                    Sociala arbetsuppgifter är arbetsuppgifter där kommunikation mellan människor är det centrala i uppgiften. Det kan exempelvis vara samarbete inom och mellan grupper, kundkontakter, instruktion och
                                                    utbildning.
                                                </li>

                                                <li>
                                                    <b>Produktionsutvecklande arbetsuppgifter</b><br>
                                                    Till detta arbetsområde hör alla arbetsuppgifter som innebär utvecklings¬arbete och förbättringsarbete på olika nivåer när det gäller process-, produkt- och metodutveckling.<br>
                                                </li>
                                            </ol>

                                        </v-expansion-panel-text>
                                    </v-expansion-panel>


                                    <v-expansion-panel>
                                        <v-expansion-panel-title color="success">
                                            {{$t('workorganisation_tab3_sbb_template_tab2_machinework_title')}}

                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text>
                                            <div v-html="$t('workorganisation_tab3_sbb_template_tab2_machinework_text')"></div>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>

                                    <v-expansion-panel>
                                        <v-expansion-panel-title color="success">
                                            {{$t('workorganisation_tab3_sbb_template_tab3_mounting_title')}}
                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text>
                                            <div v-html="$t('workorganisation_tab3_sbb_template_tab3_mounting_text')"></div>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>

                                    <v-expansion-panel>
                                        <v-expansion-panel-title color="success">
                                            {{$t('workorganisation_tab3_sbb_template_tab4_empty_template_title')}}
                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text>
                                            <div v-html="$t('workorganisation_tab3_sbb_template_tab4_empty_template_text')"></div>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>

                                </v-expansion-panels>

                            </v-expansion-panel-text>

                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-title class="tab-title">
                                {{$t('workorganisation_tab3_how_to_do_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div v-html="$t('workorganisation_tab3_how_to_do_text')"></div>
                            </v-expansion-panel-text>

                        </v-expansion-panel>

                        <v-expansion-panel eager>
                            <v-expansion-panel-title class="tab-title" data-testid="work-content-tool-expansion-title">
                                {{$t('workorganisation_tab3_tool_describe_tasks_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <work-content-and-development v-bind:disabled="writeworkcontentanddevelopment == false" v-bind:model="internalModel" v-bind:selectedJobPosition="selectedJobPosition" @position-selected="positionSelected"></work-content-and-development>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>

                </div>

                <div v-if="hidedevelopmentblocks == false" class="p-0 d-block d-md-none col-12">
                    <div data-testid="workorganisation-step-development-blocks" class="blue my-1 mobile-button rounded" v-bind:class="{'selected':step == 4}" @click="step = 4">
                        <span v-html="$t('workorganisation_developmentblocks')"></span>
                    </div>
                </div>
                <div v-if="step == 4" class="col-12 p-0">

                    <v-expansion-panels variant="accordion">
                        <v-expansion-panel eager
                            data-manual-info-block="workorganisation-development-blocks-progression"
                            data-manual-info-scope="Scenario"
                            data-manual-module="WorkOrganisation"
                            data-manual-overview-section="WorkOrganisation"
                            data-manual-complexity="Mellan"
                            data-manual-info-tags="workorganisation,development-blocks,progression">
                            <v-expansion-panel-title class="tab-title" data-manual-info-title>
                                {{$t('workorganisation_tab4_how_to_think_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div data-manual-info-body v-html="$t('workorganisation_tab4_how_to_think_text')"></div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-title class="tab-title">
                                {{$t('workorganisation_tab4_tool_create_block_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <manage-developmentblocks v-bind:disabled="writedevelopmentblocks == false" v-bind:model="internalModel" v-bind:selectedJobPosition="selectedJobPosition" @position-selected="positionSelected"></manage-developmentblocks>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>

                </div>
                
                <div v-if="hidedistributetasks == false" class="p-0 d-block d-md-none col-12">
                    <div data-testid="workorganisation-step-distribute-tasks" class="blue my-1 mobile-button rounded" v-bind:class="{'selected':step == 5}" @click="goToDistributeTasksStep">
                        <span v-html="$t('workorganisation_define_worktasks')"></span>
                    </div>
                </div>
                <div v-if="step == 5" class="col-12 p-0">
                    <v-expansion-panels variant="accordion">
                        <v-expansion-panel>
                            <v-expansion-panel-title class="tab-title">
                                {{$t('workorganisation_tab5_how_to_think_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div v-html="$t('workorganisation_tab5_how_to_think_text')"></div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-title class="tab-title">
                                {{$t('workorganisation_tab5_tool_tasks_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <manage-worktasks v-bind:disabled="writedistributetasks == false" v-bind:model="internalModel" v-bind:selectedJobPosition="selectedJobPosition" @position-selected="positionSelected"></manage-worktasks>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>

                </div>
                
                <div v-if="hideworkdescription == false" class="p-0 d-block d-md-none col-12">
                    <div data-testid="workorganisation-step-work-description" class="blue my-1 mobile-button rounded" v-bind:class="{'selected':step == 6}" @click="step = 6">
                        <span v-html="$t('workorganisation_workdescription')"></span>
                    </div>
                </div>
                <div v-if="step == 6" class="col-12 p-0">

                    <v-expansion-panels variant="accordion">
                        <v-expansion-panel eager
                            data-manual-info-block="workorganisation-work-description-result"
                            data-manual-info-scope="Scenario"
                            data-manual-module="WorkOrganisation"
                            data-manual-overview-section="WorkOrganisation"
                            data-manual-complexity="Enkel"
                            data-manual-info-tags="workorganisation,work-description,result">
                            <v-expansion-panel-title class="tab-title" data-manual-info-title>
                                {{$t('workorganisation_tab6_result_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div data-manual-info-body v-html="$t('workorganisation_tab6_result_text')"></div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                        <v-expansion-panel>
                            <v-expansion-panel-title class="tab-title">
                                {{$t('workorganisation_tab6_tool_jobdescription_title')}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div class="pt-2">
                                    Välj önskad rapport
                                </div>
                                <work-organisation-result v-bind:disabled="writeworkdescription == false" v-bind:model="internalModel" v-bind:selectedJobPosition="selectedJobPosition" @position-selected="positionSelected"></work-organisation-result>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>

                </div>
            </div>
        </div>

        
    </div>
</template>


<script>

    import CommonRule from "../../common/common-rule.vue";
    import ManageWorkpositions from "./manage-workpositions.vue"
    import WorkContentAndDevelopment from './work-content-and-development.vue'
    import ManageWorktasks from './manage-worktasks.vue'
    import ManageDevelopmentblocks from './manage-developmentblocks.vue'
    import WorkOrganisationResult from './work-organisation-result.vue'
    import WorkOrganisationService from "../../Services/WorkOrganisationService";

    export default {

        name: 'work-organisation',
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideoverview: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeoverview: {
                type: Boolean,
                required: false,
                default: false,
            },
            hidedefinepositions: {
                type: Boolean,
                required: false,
                default: false,
            },
            writedefinepositions: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideworkcontentanddevelopment: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeworkcontentanddevelopment: {
                type: Boolean,
                required: false,
                default: false,
            },
            hidedevelopmentblocks: {
                type: Boolean,
                required: false,
                default: false,
            },
            writedevelopmentblocks: {
                type: Boolean,
                required: false,
                default: false,
            },
            hidedistributetasks: {
                type: Boolean,
                required: false,
                default: false,
            },
            writedistributetasks: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideworkdescription: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeworkdescription: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components:{
            CommonRule,
            ManageWorkpositions,
            WorkContentAndDevelopment,
            ManageWorktasks,
            ManageDevelopmentblocks,
            WorkOrganisationResult
        },
        methods: {
            positionSelected(newVal) {
                this.selectedJobPosition = newVal;
            },
            jobPositionId(row) {
                if (!row) {
                    return null;
                }
                var id = row.JobPositionId !== undefined ? row.JobPositionId : row.jobPositionId;
                return id === undefined || id === null ? null : id;
            },
            jobPositionName(row) {
                if (!row) {
                    return '';
                }
                return row.Name !== undefined ? row.Name : row.name || '';
            },
            debugWorkOrganisationFlow(eventName, payload) {
                try {
                    var enabled = window.location.hostname === 'localhost'
                        || window.location.hostname === '127.0.0.1'
                        || window.localStorage.getItem('swc.workOrganisation.debug') === 'true';
                    if (!enabled) {
                        return;
                    }
                    console.debug('[SWC WorkOrganisation]', 'work-organisation:' + eventName, payload || {});
                }
                catch (error) {
                    // Ignore diagnostics failures.
                }
            },
            summarizeJobPositions(jobPositions) {
                if (!Array.isArray(jobPositions)) {
                    return { count: 0, first: [] };
                }
                var self = this;
                return {
                    count: jobPositions.length,
                    first: jobPositions.slice(0, 5).map(function (p) {
                        return {
                            id: self.jobPositionId(p),
                            name: self.jobPositionName(p),
                        };
                    }),
                };
            },
            jobPositionsChanged(jobPositions) {
                if (Array.isArray(jobPositions) && this.internalModel) {
                    this.debugWorkOrganisationFlow('jobPositionsChanged:received', this.summarizeJobPositions(jobPositions));
                    jobPositions = this.sortJobPositionsByNewest(jobPositions);
                    var previousIds = new Set();
                    var previous = Array.isArray(this.internalModel.JobPositions)
                        ? this.internalModel.JobPositions
                        : [];
                    for (var i = 0; i < previous.length; i++) {
                        var previousId = this.jobPositionId(previous[i]);
                        if (previousId > 0) {
                            previousIds.add(previousId);
                        }
                    }

                    this.internalModel.JobPositions = jobPositions;

                    var newestAddedId = null;
                    for (var j = 0; j < jobPositions.length; j++) {
                        var id = this.jobPositionId(jobPositions[j]);
                        if (id > 0 && !previousIds.has(id)) {
                            if (newestAddedId === null || id > newestAddedId) {
                                newestAddedId = id;
                            }
                        }
                    }
                    if (newestAddedId !== null) {
                        this.selectedJobPosition = newestAddedId;
                    }
                    this.debugWorkOrganisationFlow('jobPositionsChanged:applied', {
                        selectedJobPosition: this.selectedJobPosition,
                        newestAddedId: newestAddedId,
                        jobPositions: this.summarizeJobPositions(this.internalModel.JobPositions),
                    });
                }
            },
            ensureSelectedJobPositionFromList() {
                var list = this.internalModel && Array.isArray(this.internalModel.JobPositions)
                    ? this.internalModel.JobPositions
                    : [];
                if (list.length === 0) {
                    return;
                }

                var selectedIdRaw = this.selectedJobPosition;
                var selectedIdNumber = Number(selectedIdRaw);
                var selectedId = Number.isNaN(selectedIdNumber) ? selectedIdRaw : selectedIdNumber;
                var selectedExists = false;
                var highestId = null;
                for (var i = 0; i < list.length; i++) {
                    var rawId = this.jobPositionId(list[i]);
                    var idNumber = Number(rawId);
                    var id = Number.isNaN(idNumber) ? rawId : idNumber;
                    if (id > 0 && id === selectedId) {
                        selectedExists = true;
                    }
                    if (id > 0 && (highestId === null || id > highestId)) {
                        highestId = id;
                    }
                }

                if (highestId !== null && (!selectedExists || highestId > selectedId)) {
                    this.selectedJobPosition = highestId;
                }
                this.debugWorkOrganisationFlow('ensureSelectedJobPositionFromList', {
                    previousSelectedJobPosition: selectedIdRaw,
                    selectedExists: selectedExists,
                    highestId: highestId,
                    selectedJobPosition: this.selectedJobPosition,
                    jobPositions: this.summarizeJobPositions(list),
                });
            },
            async refreshJobPositionsFromServer() {
                try {
                    var jobPositions = await WorkOrganisationService.getJobPositions();
                    if (this.internalModel) {
                        this.internalModel.JobPositions = this.sortJobPositionsByNewest(jobPositions);
                        this.debugWorkOrganisationFlow('refreshJobPositionsFromServer', this.summarizeJobPositions(this.internalModel.JobPositions));
                    }
                }
                catch (error) {
                    console.error(error);
                }
            },
            async goToWorkContentStep() {
                const previous = (this.internalModel && Array.isArray(this.internalModel.JobPositions))
                    ? this.internalModel.JobPositions.slice()
                    : [];
                this.debugWorkOrganisationFlow('goToWorkContentStep:start', {
                    selectedJobPosition: this.selectedJobPosition,
                    previous: this.summarizeJobPositions(previous),
                });
                try {
                    var server = await WorkOrganisationService.getJobPositions();
                    if (this.internalModel) {
                        this.internalModel.JobPositions = this.mergeJobPositionLists(previous, server);
                        this.ensureSelectedJobPositionFromList();
                        this.debugWorkOrganisationFlow('goToWorkContentStep:merged', {
                            selectedJobPosition: this.selectedJobPosition,
                            server: this.summarizeJobPositions(server),
                            merged: this.summarizeJobPositions(this.internalModel.JobPositions),
                        });
                    }
                }
                catch (error) {
                    console.error(error);
                }
                this.step = 3;
                await this.$nextTick();
            },
            mergeJobPositionLists(previous, server) {
                var self = this;
                var serverById = new Map();
                if (Array.isArray(server)) {
                    for (var i = 0; i < server.length; i++) {
                        var s = server[i];
                        var sid = self.jobPositionId(s);
                        if (s && sid > 0) {
                            serverById.set(sid, s);
                        }
                    }
                }
                var merged = [];
                var seen = new Set();
                for (var j = 0; j < previous.length; j++) {
                    var p = previous[j];
                    if (!p) {
                        continue;
                    }
                    var pid = self.jobPositionId(p);
                    if (pid === undefined || pid === null || pid <= 0) {
                        merged.push(p);
                        continue;
                    }
                    if (serverById.has(pid)) {
                        merged.push(serverById.get(pid));
                    }
                    else {
                        merged.push(p);
                    }
                    seen.add(pid);
                }
                if (Array.isArray(server)) {
                    for (var k = 0; k < server.length; k++) {
                        var row = server[k];
                        var rid = self.jobPositionId(row);
                        if (row && rid > 0 && !seen.has(rid)) {
                            merged.push(row);
                            seen.add(rid);
                        }
                    }
                }
                return this.sortJobPositionsByNewest(merged);
            },
            sortJobPositionsByNewest(jobPositions) {
                if (!Array.isArray(jobPositions)) {
                    return [];
                }
                var self = this;
                return jobPositions.slice().sort(function (a, b) {
                    var aid = Number(self.jobPositionId(a));
                    var bid = Number(self.jobPositionId(b));
                    if (Number.isNaN(aid)) {
                        aid = 0;
                    }
                    if (Number.isNaN(bid)) {
                        bid = 0;
                    }
                    return bid - aid;
                });
            },
            goToDefinePositionsStep() {
                // Ingen refresh här: efter nyskapad befattning kan GET ännu inte innehålla den (samma som goToWorkContentStep).
                this.step = 2;
            },
            async goToDistributeTasksStep() {
                const previous = (this.internalModel && Array.isArray(this.internalModel.JobPositions))
                    ? this.internalModel.JobPositions.slice()
                    : [];
                this.debugWorkOrganisationFlow('goToDistributeTasksStep:start', {
                    selectedJobPosition: this.selectedJobPosition,
                    previous: this.summarizeJobPositions(previous),
                });
                try {
                    var server = await WorkOrganisationService.getJobPositions();
                    if (this.internalModel) {
                        this.internalModel.JobPositions = this.mergeJobPositionLists(previous, server);
                        this.ensureSelectedJobPositionFromList();
                        this.debugWorkOrganisationFlow('goToDistributeTasksStep:merged', {
                            selectedJobPosition: this.selectedJobPosition,
                            server: this.summarizeJobPositions(server),
                            merged: this.summarizeJobPositions(this.internalModel.JobPositions),
                        });
                    }
                }
                catch (error) {
                    console.error(error);
                }
                this.step = 5;
                await this.$nextTick();
            },
        },

        data() {
            return {
                step: 1,
                internalModel:{
                    JobPositions: [],
                    JobTaskSuggestions: [],
                },
                selectedJobPosition:null,
            };
        },
        mounted() {
            this.internalModel = this.model;
            /*
            alert("hideoverview:" + this.hideoverview)
            alert("writeoverview:" + this.writeoverview)
            alert("hidedefinepositions:" + this.hidedefinepositions)
            alert("writedefinepositions:" + this.writedefinepositions)
            alert("hideworkcontentanddevelopment:" + this.hideworkcontentanddevelopment)
            alert("writeworkcontentanddevelopment:" + this.writeworkcontentanddevelopment)
            alert("hidedevelopmentblocks:" + this.hidedevelopmentblocks)
            alert("writedevelopmentblocks:" + this.writedevelopmentblocks)
            alert("hidedistributetasks:" + this.hidedistributetasks)
            alert("writedistributetasks:" + this.writedistributetasks)
            alert("hideworkdescription:" + this.hideworkdescription)
            alert("writeworkdescription:" + this.writeworkdescription)
            */
        },
        setup() {
            return {  }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .large-button {
        text-align: center;
        display: grid;
        align-items: center;
        width: 130px;
        min-height: 90px;
        background-color: #4B6FB2;
        color: white;
        cursor: pointer;
        font-size: 15px;
    }

    .large-button.selected {
        background-color: #B1C1E8 !important;
        color:black !important;
    }

    .input{
        border:none;
        border-bottom:1px solid #ccc;
    }

    .drop {
        color: black;
        text-decoration: none;
        font-size: 20px;
        display: block;
        line-height: 0px;
        margin-top: 5px;
    }

    .tab-title {
        background-color: #4B6FB2;
        color: white;
    }
    
</style>
